import { UNINITIALIZED, STARTED, SUCCEEDED } from '../constants/RequestStatusTypes';
import { FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED, FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED, SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL } from '../actions/ActionTypes';
const initialState = {
  hasSeenPortalFmoOnboarding: false,
  status: UNINITIALIZED
};
export default function onboardingSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED:
      return Object.assign({}, state, {
        status: STARTED
      });
    case FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED:
      {
        var _action$payload;
        return Object.assign({}, state, {
          status: SUCCEEDED,
          hasSeenPortalFmoOnboarding: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.hasSeenFmoTour
        });
      }
    case SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL:
      {
        return Object.assign({}, state, {
          hasSeenPortalFmoOnboarding: action.payload
        });
      }
    default:
      return state;
  }
}